import { render, staticRenderFns } from "./PriceDiscountDetails.vue?vue&type=template&id=66479c78&scoped=true"
import script from "./PriceDiscountDetails.vue?vue&type=script&lang=js"
export * from "./PriceDiscountDetails.vue?vue&type=script&lang=js"
import style0 from "./PriceDiscountDetails.vue?vue&type=style&index=0&id=66479c78&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66479c78",
  null
  
)

export default component.exports